import React, { useState, useRef, useEffect } from "react";
import img from "../Assets/bike2.png";
import { FaArrowRight } from "react-icons/fa";

const bikes = [
  {
    name: "Bullet 350",
    tag: "Classic Legend",
    rpm: "6,100 rpm",
    power: "20.2 bhp",
    torque: "27 Nm",
    price: "₹1,74,875",
    badge: "Best Seller",
    img: img,
  },
  {
    name: "Super Meteor 450",
    tag: "Cruiser Beast",
    rpm: "7,250 rpm",
    power: "40.0 bhp",
    torque: "45 Nm",
    price: "₹3,68,085",
    badge: "New Arrival",
    img: img,
  },
  {
    name: "Hunter 350",
    tag: "Urban Warrior",
    rpm: "6,100 rpm",
    power: "20.2 bhp",
    torque: "27 Nm",
    price: "₹1,49,900",
    badge: "Save 15%",
    img: img,
  },
  {
    name: "Meteor 350",
    tag: "Road Tripper",
    rpm: "6,100 rpm",
    power: "20.2 bhp",
    torque: "27 Nm",
    price: "₹2,08,270",
    badge: "Popular",
    img: img,
  },
];

const Services = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(null);
const [showAll, setShowAll] = useState(false);
const [openBooking, setOpenBooking] = useState(false);
const [selectedBike, setSelectedBike] = useState(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style>{`
        /* ── FONT CHANGE: Oswald (display) + DM Sans (body) ── */
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=DM+Sans:wght@400;500;600&family=Barlow+Condensed:wght@400;600;700;800&display=swap');

        .font-bebas       { font-family: 'Oswald', sans-serif; letter-spacing: 0.02em; }
        .font-barlow      { font-family: 'DM Sans', sans-serif; }
        .font-barlow-cond { font-family: 'Barlow Condensed', sans-serif; }

        /* Section grid bg */
        .services-grid-bg {
          background-image:
            linear-gradient(rgba(212,175,55,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(212,175,55,0.03) 1px, transparent 1px);
          background-size: 56px 56px;
        }

        /* Card */
        .bike-card {
          position: relative;
          background: #111111111;
          border: 1px solid rgba(255,255,255,0.05);
          overflow: hidden;
          transition: border-color 0.35s, transform 0.35s;
          clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 20px 100%, 0 calc(100% - 20px));
        }
        .bike-card:hover {
          border-color: rgba(212,175,55,0.5);
          transform: translateY(-6px);
        }

        .bike-card::before {
          content: '';
          position: absolute;
          top: 0; right: 0;
          width: 0; height: 0;
          border-style: solid;
          border-width: 0 40px 40px 0;
          border-color: transparent #D4AF37 transparent transparent;
          z-index: 2;
          transition: border-width 0.35s;
        }
        .bike-card:hover::before {
          border-width: 0 48px 48px 0;
        }

        .bike-card::after {
          content: '';
          position: absolute;
          bottom: -60px; left: 50%;
          transform: translateX(-50%);
          width: 200px; height: 100px;
          background: radial-gradient(circle, rgba(212,175,55,0.18) 0%, transparent 70%);
          transition: opacity 0.4s;
          opacity: 0;
          pointer-events: none;
        }
        .bike-card:hover::after { opacity: 1; }

        .bike-card-img {
          transition: transform 0.5s ease, filter 0.5s ease;
          filter: drop-shadow(0 12px 30px rgba(212,175,55,0.15));
        }
        .bike-card:hover .bike-card-img {
          transform: scale(1.08) translateY(-6px);
          filter: drop-shadow(0 20px 50px rgba(212,175,55,0.35));
        }

        .stat-pill {
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.07);
          transition: background 0.3s, border-color 0.3s;
        }
        .bike-card:hover .stat-pill {
          background: rgba(212,175,55,0.08);
          border-color: rgba(212,175,55,0.2);
        }

        .book-btn {
          clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%);
          transition: background 0.3s;
        }
        .book-btn:hover { background: #E5C158 !important; }

        .card-reveal {
          opacity: 0;
          transform: translateY(40px);
          transition: opacity 0.7s ease, transform 0.7s ease;
        }
        .card-reveal.shown {
          opacity: 1;
          transform: translateY(0);
        }

        .section-watermark {
          font-family: 'Oswald', sans-serif;
          font-size: clamp(70px, 14vw, 180px);
          color: rgba(212,175,55,0.04);
          letter-spacing: -3px;
          pointer-events: none;
          user-select: none;
          white-space: nowrap;
          line-height: 1;
        }

        .ticker-track {
          display: flex;
          gap: 80px;
          white-space: nowrap;
          animation: tickerScroll 22s linear infinite;
        }
        @keyframes tickerScroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }

        .price-shimmer {
          background: linear-gradient(90deg, #F5F5F5 30%, #D4AF37 50%, #F5F5F5 70%);
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          transition: background-position 0.5s;
        }
        .bike-card:hover .price-shimmer {
          background-position: right center;
        }
          @keyframes slideLeft {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.animate-slideLeft {
  animation: slideLeft 0.4s ease forwards;
}
      `}</style>

      <section
        ref={sectionRef}
        id="motorcycles"
        className="relative w-full bg-[#050505] py-24 px-8 overflow-hidden"
      >
        <div className="services-grid-bg absolute inset-0 z-0 pointer-events-none" />
        <div className="section-watermark absolute top-6 left-0 z-0 select-none">MOTORCYCLES</div>
        <div className="absolute left-0 top-1/4 bottom-1/4 w-[3px] bg-gradient-to-b from-transparent via-[#D4AF37] to-transparent opacity-40" />

        <div className="relative z-10 max-w-7xl mx-auto">

          {/* ── HEADER ── */}
          <div className={`card-reveal ${visible ? "shown" : ""} flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16`}>
            <div>
              <div className="flex items-center gap-3 font-barlow-cond text-[11px] tracking-[4px] uppercase text-[#D4AF37] mb-4">
                <span className="w-8 h-px bg-[#D4AF37]" />
                Our Collection
              </div>
              <h2
                className="font-bebas leading-[0.9]"
                style={{ fontSize: "clamp(48px, 7vw, 90px)" }}
              >
                <span className="text-[#F5F5F5]">Our </span>
                <span className="text-[#D4AF37]">Motor</span>
                <span
                  className="font-bebas"
                  style={{ WebkitTextStroke: "1.5px #F5F5F5", color: "transparent" }}
                >
                  cycles
                </span>
              </h2>
            </div>

            <div className="flex flex-col gap-2 md:items-end">
              {/* Paragraph — 16px, brighter */}
              <p className="font-barlow text-[#9CA3AF] text-[16px] max-w-[300px] md:text-right leading-[1.8]">
                Choose your perfect machine from our handpicked premium collection.
              </p>
           <button
  onClick={() => setShowAll(true)}
  className="self-start flex md:self-auto items-center gap-2 font-barlow-cond text-[12px] tracking-[3px] uppercase text-[#D4AF37] border border-[#D4AF37]/30 px-5 py-2 hover:bg-[#D4AF37] hover:text-white transition-all duration-300"
>
  View All
  <FaArrowRight />
</button>
            </div>
          </div>

          {/* ── BIKE GRID ── */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {bikes.map((bike, index) => (
              <div
                key={index}
                className={`bike-card card-reveal ${visible ? "shown" : ""}`}
                style={{ transitionDelay: `${0.1 + index * 0.12}s` }}
                onMouseEnter={() => setHovered(index)}
                onMouseLeave={() => setHovered(null)}
              >
                {/* IMAGE ZONE */}
                <div className="relative bg-[#0d0d0d] px-6 pt-8 pb-4 flex items-center justify-center" style={{ minHeight: 200 }}>
                  <span
                    className="absolute bottom-1 right-3 font-bebas text-[#D4AF37]/05 select-none pointer-events-none"
                    style={{ fontSize: 64 }}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  {hovered === index && (
                    <div
                      className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full pointer-events-none"
                      style={{
                        width: 140, height: 30,
                        background: "radial-gradient(ellipse, rgba(212,175,55,0.35) 0%, transparent 70%)",
                      }}
                    />
                  )}
                  <img
                    src={bike.img}
                    alt={bike.name}
                    className="bike-card-img w-full object-contain"
                    style={{ maxHeight: 160 }}
                  />
                </div>

                {/* CONTENT ZONE */}
                <div className="px-5 pt-4 pb-5 flex flex-col gap-3">
                  <span className="self-start font-barlow-cond text-[10px] tracking-[3px] uppercase text-[#D4AF37] bg-[#D4AF37]/10 border border-[#D4AF37]/20 px-3 py-1">
                    {bike.badge}
                  </span>

                  <div>
                    <h3 className="font-bebas text-[26px] text-[#F5F5F5] leading-none tracking-wide">
                      {bike.name}
                    </h3>
                    {/* Tag — bumped to 12px, brighter */}
                    <p className="font-barlow-cond text-[12px] tracking-[2px] uppercase text-[#666] mt-1">
                      {bike.tag}
                    </p>
                  </div>

                  <div className="h-px bg-gradient-to-r from-[#D4AF37]/30 to-transparent" />

                  {/* Stats row */}
                  <div className="flex gap-2">
                    {[
                      { label: "RPM", value: bike.rpm },
                      { label: "Power", value: bike.power },
                      { label: "Torque", value: bike.torque },
                    ].map((s) => (
                      <div key={s.label} className="stat-pill flex-1 rounded-none px-2 py-2 text-center">
                        {/* Stat value — brighter */}
                        <div className="font-barlow-cond text-[11px] font-bold text-[#e8e8e0]">{s.value}</div>
                        <div className="font-barlow-cond text-[9px] tracking-[2px] uppercase text-[#555]">{s.label}</div>
                      </div>
                    ))}
                  </div>

                  <div className="flex items-baseline justify-between mt-1">
                    <span className="font-barlow-cond text-[10px] tracking-[2px] uppercase text-[#555]">Ex-showroom</span>
                    <span className="price-shimmer font-bebas text-[24px] leading-none">{bike.price}</span>
                  </div>

<button
  onClick={() => {
    setSelectedBike(bike);
    setOpenBooking(true);
  }}
  className="book-btn mt-1 w-full flex items-center justify-center gap-2 bg-[#D4AF37] text-white py-[10px] font-barlow-cond text-[12px] font-bold tracking-[2px] uppercase"
>
                    Book Now
                    <span className="text-base"><FaArrowRight /></span>
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* BOTTOM TICKER */}
          <div className="mt-20 border-t border-b border-[#D4AF37]/10 py-3 overflow-hidden -mx-6 md:-mx-12">
            <div className="ticker-track">
              {[...Array(2)].flatMap(() =>
                ["Bullet 350", "Super Meteor 450", "Hunter 350", "Meteor 350", "Continental GT 650", "Interceptor 650", "Scram 411", "Himalayan"].map((name, i) => (
                  <div key={`${name}-${i}`} className="flex items-center gap-5 flex-shrink-0">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
                    <span className="font-barlow-cond text-[12px] tracking-[3px] uppercase text-[#444]">{name}</span>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        {showAll && (
  <div className="fixed inset-0 z-[999] bg-black/80 backdrop-blur-sm flex justify-end">
    
    {/* PANEL */}
    <div className="w-full md:w-[85%] lg:w-[75%] h-full bg-[#080808] overflow-y-auto animate-slideLeft">

      {/* HEADER */}
      <div className="sticky top-0 z-20 bg-[#080808] border-b border-[#D4AF37]/20 px-6 md:px-10 py-5 flex items-center justify-between">
        <h2 className="font-bebas text-4xl md:text-5xl text-[#D4AF37] tracking-wide">
          All Motorcycles
        </h2>

        <button
          onClick={() => setShowAll(false)}
          className="w-10 h-10 border border-[#D4AF37]/30 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300 text-xl"
        >
          ✕
        </button>
      </div>

      {/* CONTENT */}
      <div className="p-6 md:p-10 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">

        {bikes.map((bike, index) => (
          <div
            key={index}
            className="bg-[#111] border border-[#D4AF37]/10 hover:border-[#D4AF37]/40 transition-all duration-300 overflow-hidden group"
          >
            {/* IMAGE */}
            <div className="bg-[#0d0d0d] p-6 flex items-center justify-center h-[240px] overflow-hidden">
              <img
                src={bike.img}
                alt={bike.name}
                className="w-full object-contain group-hover:scale-110 transition-transform duration-500"
              />
            </div>

            {/* DETAILS */}
            <div className="p-5 flex flex-col gap-4">

              <div>
                <h3 className="font-bebas text-3xl text-white">
                  {bike.name}
                </h3>

                <p className="text-[#888] uppercase tracking-[2px] text-xs">
                  {bike.tag}
                </p>
              </div>

              <div className="grid grid-cols-3 gap-2">
                <div className="bg-[#1a1a1a] p-3 text-center">
                  <p className="text-[#D4AF37] text-sm font-bold">
                    {bike.rpm}
                  </p>
                  <span className="text-[#555] text-[10px] uppercase">
                    RPM
                  </span>
                </div>

                <div className="bg-[#1a1a1a] p-3 text-center">
                  <p className="text-[#D4AF37] text-sm font-bold">
                    {bike.power}
                  </p>
                  <span className="text-[#555] text-[10px] uppercase">
                    Power
                  </span>
                </div>

                <div className="bg-[#1a1a1a] p-3 text-center">
                  <p className="text-[#D4AF37] text-sm font-bold">
                    {bike.torque}
                  </p>
                  <span className="text-[#555] text-[10px] uppercase">
                    Torque
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between mt-2">
                <span className="text-[#D4AF37] font-bebas text-3xl">
                  {bike.price}
                </span>

                <button  onClick={() => {
    setSelectedBike(bike);
    setOpenBooking(true);
  }} className="bg-[#D4AF37] hover:bg-[#e5c158] text-black px-5 py-2 text-xs uppercase tracking-[2px] font-bold transition-all duration-300 flex items-center gap-2">
                  Book Now
                  <FaArrowRight />
                </button>
              </div>
            </div>
          </div>
        ))}

      </div>
    </div>
  </div>
)}
{openBooking && (
  <div className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">

    {/* MODAL */}
    <div className="w-full max-w-2xl bg-[#0b0b0b] border border-[#D4AF37]/20 overflow-hidden animate-modalShow">

      {/* HEADER */}
      <div className="flex items-center justify-between px-6 py-5 border-b border-[#D4AF37]/10">
        <div>
          <h2 className="font-bebas text-4xl text-[#D4AF37]">
            Book Test Ride
          </h2>

          <p className="text-[#777] text-sm mt-1">
            {selectedBike?.name}
          </p>
        </div>

        <button
          onClick={() => setOpenBooking(false)}
          className="w-10 h-10 border border-[#D4AF37]/20 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
        >
          ✕
        </button>
      </div>

      {/* FORM */}
      <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-5">

        {/* Name */}
        <div className="flex flex-col gap-2">
          <label className="text-[#999] text-sm uppercase tracking-[2px]">
            Full Name
          </label>

          <input
            type="text"
            placeholder="Enter your name"
            className="bg-[#111] border border-[#222] focus:border-[#D4AF37] outline-none px-4 py-3 text-white transition-all"
          />
        </div>

        {/* Phone */}
        <div className="flex flex-col gap-2">
          <label className="text-[#999] text-sm uppercase tracking-[2px]">
            Phone Number
          </label>

          <input
            type="text"
            placeholder="+91 XXXXX XXXXX"
            className="bg-[#111] border border-[#222] focus:border-[#D4AF37] outline-none px-4 py-3 text-white transition-all"
          />
        </div>

        {/* Email */}
        <div className="flex flex-col gap-2">
          <label className="text-[#999] text-sm uppercase tracking-[2px]">
            Email
          </label>

          <input
            type="email"
            placeholder="Enter email"
            className="bg-[#111] border border-[#222] focus:border-[#D4AF37] outline-none px-4 py-3 text-white transition-all"
          />
        </div>

        {/* City */}
        <div className="flex flex-col gap-2">
          <label className="text-[#999] text-sm uppercase tracking-[2px]">
            City
          </label>

          <input
            type="text"
            placeholder="Enter city"
            className="bg-[#111] border border-[#222] focus:border-[#D4AF37] outline-none px-4 py-3 text-white transition-all"
          />
        </div>

        {/* Bike */}
        <div className="md:col-span-2 flex flex-col gap-2">
          <label className="text-[#999] text-sm uppercase tracking-[2px]">
            Selected Motorcycle
          </label>

          <input
            type="text"
            value={selectedBike?.name || ""}
            readOnly
            className="bg-[#151515] border border-[#D4AF37]/20 px-4 py-3 text-[#D4AF37]"
          />
        </div>

        {/* Message */}
        <div className="md:col-span-2 flex flex-col gap-2">
          <label className="text-[#999] text-sm uppercase tracking-[2px]">
            Message
          </label>

          <textarea
            rows="4"
            placeholder="I'm interested in this motorcycle..."
            className="bg-[#111] border border-[#222] focus:border-[#D4AF37] outline-none px-4 py-3 text-white transition-all resize-none"
          />
        </div>

        {/* BUTTON */}
        <div className="md:col-span-2 flex justify-end">
          <button className="bg-[#D4AF37] hover:bg-[#e5c158] text-black px-8 py-3 uppercase tracking-[2px] text-sm font-bold transition-all duration-300 flex items-center gap-3">
            Submit Booking
            <FaArrowRight />
          </button>
        </div>

      </div>
    </div>
  </div>
)}
      </section>
    </>
  );
};

export default Services;